import { Components, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const MuiFormLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body2,
      color: theme.palette.neutral.onSurface,
      '&.Mui-focused': {
        color: theme.palette.neutral.onSurface,
      },
    }),
  },

} as Components<Theme>['MuiFormLabel'];

export const MuiFormControlLabel = {
  defaultProps: {
    slotProps: {
      typography: { variant: 'body1' }
    }
  },
  styleOverrides: {
    root: ({ theme }) => ({
      marginRight: 0,
      color: theme.palette.neutral.onSurface,
    }),
    label: ({ theme }) => ({
      overflowX: 'hidden',
      '&.Mui-disabled': {
        color: theme.palette.action.disabled,
      },
    }),
    labelPlacementTop: {
      alignItems: 'flex-start',
      marginLeft: 0,
    },
    labelPlacementStart: ({ theme }) => ({
      marginLeft: 0,
      '& .MuiSwitch-root': {
        marginLeft: theme.spacing(1.5),
      }
    }),
    labelPlacementEnd: ({ theme }: { theme: Theme }) => ({
      marginLeft: 0,
      '& .MuiSwitch-root': {
        marginRight: theme.spacing(1.5),
      }
    }),
  }
} as Components<Theme>['MuiFormControlLabel'];

export const MuiRadio = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const color = ownerState.color!;
      return {
        marginRight: 0,
        color: theme.palette.neutral.onSurfaceVariant,
        '&:hover': {
          backgroundColor: alpha(theme.palette.neutral.onSurfaceVariant, theme.palette.action.hoverOpacity)
        },
        '&:active': {
          backgroundColor: alpha(theme.palette.neutral.onSurfaceVariant, theme.palette.action.activatedOpacity)
        },
        '&.Mui-focusVisible': {
          backgroundColor: alpha(theme.palette.neutral.onSurfaceVariant, theme.palette.action.focusOpacity)
        },
        '&.Mui-checked': {
          '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
          },
          '&:active': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.activatedOpacity)
          },
          '&.Mui-focusVisible': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.focusOpacity)
          },
        },
        '&.Mui-disabled': {
          color: theme.palette.action.disabled
        }
      };
    },
  }
} as Components<Theme>['MuiRadio'];